export default function WearLayerThicknessFacet({
  handleFilterClick,
  productWearLayerThickness,
}) {
  // console.log(productWearLayerThickness);
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productWearLayerThickness = sortObject(productWearLayerThickness);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("wear_layer_thickness_facet") &&
    plpFacetLabel.wear_layer_thickness_facet != ""
      ? plpFacetLabel.wear_layer_thickness_facet
      : "Wear Layer";

  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productWearLayerThickness).map((wear_layer, i) => {
          if (wear_layer && productWearLayerThickness[wear_layer] > 0) {
            return (
              <div>
                <span
                  id={`wear_layer-filter-${i}`}
                  key={i}
                  data-value={`${wear_layer.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick(
                      "wear_layer_thickness_facet",
                      e.target.dataset.value
                    )
                  }>
                  {" "}
                  {wear_layer} {` (${productWearLayerThickness[wear_layer]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
